import { useLocation } from 'react-router-dom';

export const useRoutePath = () => {
  const { pathname } = useLocation();

  const pathSegment = (index) => {
    return pathname.split('/')[index] ?? '';
  };

  const parentPath = pathSegment(2);

  return {
    pathSegment,
    parentPath,
  };
};
